import { render, staticRenderFns } from "./LandingPageCard.vue?vue&type=template&id=1d7efeb0&scoped=true"
import script from "./LandingPageCard.vue?vue&type=script&lang=js"
export * from "./LandingPageCard.vue?vue&type=script&lang=js"
import style0 from "./LandingPageCard.vue?vue&type=style&index=0&id=1d7efeb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7efeb0",
  null
  
)

export default component.exports